import axios from 'axios';
import { API_url } from '../api.setup';
import { enqueueSnackbar } from 'notistack';
import {
  BankAccountsModel,
  BankAccountTypesModel
} from 'src/models/servicePartner/backAccountModel';

const API_Controller = '/ServicePartnerBankAccount';

export const ServicePartnerBankAccountsServices = {
  getAllData: async (spId: number) => {
    try {
      const respons = await axios.get(
        `${API_url}${API_Controller}/getServicePartnerBankAccountByServicePartnerId?servicePartnerid=${spId}`
      );
      return respons.data as BankAccountsModel[];
    } catch (error) {
      throw error;
    }
  },

  getBankAccountTypes: async () => {
    try {
      const respons = await axios.get(
        `${API_url}${API_Controller}/getAccountTypes`
      );
      return respons.data as BankAccountTypesModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (data) => {
    const remod = {
      id: data.id,
      accountName: data.accountName,
      accountNumber: data.accountNumber,
      bankName: data.bankName,
      ifscCode: data.ifscCode,
      micrCode: data.micrCode,
      servicePartnerId: data.servicePartnerId,
      accountTypeId: data.accountTypeId,
      isActive: data.isActive
    };
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, remod);
      return response.data as BankAccountsModel;
    } catch (error) {
      throw error;
    }
  },

  updateData: async (data) => {
    const remod = {
      id: data.id,
      accountName: data.accountName,
      accountNumber: data.accountNumber,
      bankName: data.bankName,
      ifscCode: data.ifscCode,
      micrCode: data.micrCode,
      servicePartnerId: data.servicePartnerId,
      accountTypeId: data.accountTypeId,
      isActive: data.isActive
    };
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        remod
      );
      return response.data as BankAccountsModel;
    } catch (error) {
      throw error;
    }
  },

  deleteData: async (baId: number) => {
    try {
      const respons = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${baId}`
      );
      return respons.data;
    } catch (error) {
      throw error;
    }
  }
};
